import { createContext } from "react";

const CartContext = createContext();
CartContext.displayName = "Cart";

export default CartContext;
